import { ValidationError } from 'yup';

interface Errors {
  [key: string]: string;
}

export default function getValidationErrors(err: ValidationError) {
  let validationErrors: Errors = {};
  err.inner.forEach((erro) => {
    validationErrors[erro.path] = erro.message;
  });
  return validationErrors;
}
